module.exports = function anonymous(locals, filters, escape, rethrow) {
    escape = escape || function(html) {
        return String(html).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/'/g, "&#39;").replace(/"/g, "&quot;");
    };
    var __stack = {
        lineno: 1,
        input: '<% if (typeof title != \'undefined\') { %>\n  <div class="title">\n    <p><%= title %></p>\n  </div>\n  <div class="content-wrapper">\n  </div>\n<% } else { %>\n  <div class="content-wrapper no-title">\n  </div>\n<% } %>\n\n',
        filename: "."
    };
    function rethrow(err, str, filename, lineno) {
        var lines = str.split("\n"), start = Math.max(lineno - 3, 0), end = Math.min(lines.length, lineno + 3);
        var context = lines.slice(start, end).map(function(line, i) {
            var curr = i + start + 1;
            return (curr == lineno ? " >> " : "    ") + curr + "| " + line;
        }).join("\n");
        err.path = filename;
        err.message = (filename || "ejs") + ":" + lineno + "\n" + context + "\n\n" + err.message;
        throw err;
    }
    try {
        var buf = [];
        with (locals || {}) {
            (function() {
                buf.push("");
                __stack.lineno = 1;
                if (typeof title != "undefined") {
                    buf.push('\n  <div class="title">\n    <p>', escape((__stack.lineno = 3, title)), '</p>\n  </div>\n  <div class="content-wrapper">\n  </div>\n');
                    __stack.lineno = 7;
                } else {
                    buf.push('\n  <div class="content-wrapper no-title">\n  </div>\n');
                    __stack.lineno = 10;
                }
                buf.push("\n\n");
            })();
        }
        return buf.join("");
    } catch (err) {
        rethrow(err, __stack.input, __stack.filename, __stack.lineno);
    }
}


//////////////////
// WEBPACK FOOTER
// ./src/cam-context-switcher/templates/cam-context-switcher-card-list.ejs
// module id = 274
// module chunks = 0 1